"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticReportSystemData = exports.analyticReportSuccess = exports.analyticReportReset = exports.analyticReportFilterData = exports.analyticReportError = void 0;
var _analyticReport = require("./analyticReport.constant");
// @flow

// common success
var analyticReportSuccess = function analyticReportSuccess(actionType, data) {
  return {
    type: _analyticReport.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.analyticReportSuccess = analyticReportSuccess;
var analyticReportError = function analyticReportError(actionType, error) {
  return {
    type: _analyticReport.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * system data
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.analyticReportError = analyticReportError;
var analyticReportSystemData = function analyticReportSystemData(data) {
  return {
    type: _analyticReport.actionTypes.SYSTEM_DATA,
    payload: data
  };
};

/**
 * filter
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.analyticReportSystemData = analyticReportSystemData;
var analyticReportFilterData = function analyticReportFilterData(data) {
  return {
    type: _analyticReport.actionTypes.FILTER_DATA,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.analyticReportFilterData = analyticReportFilterData;
var analyticReportReset = function analyticReportReset(data) {
  return {
    type: _analyticReport.actionTypes.RESET,
    payload: data
  };
};
exports.analyticReportReset = analyticReportReset;